import type { ListBuilderList } from '../../../types';
import { createClientColumnsNoLifecycle } from '../columns';
import {
	createClientKanbanConfig,
	DEFAULT_LIST_REQUIRED_FIELDS,
} from '../shared';

/**
 * My Clients list configuration
 * User's assigned clients filtered by salesperson
 */
export const myClientsList: ListBuilderList = {
	id: 'list-1750391641362',
	cacheTTL: 600000,
	name: 'My Clients',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	columns: createClientColumnsNoLifecycle(),
	description: 'My clients',
	defaultSortId: 'column-client-name-asc',
	requiredFields: DEFAULT_LIST_REQUIRED_FIELDS,
	sortOrder: 11,
	filterRules: {
		salespeople: {
			defaultValue: [],
			additionalValues: [
				{
					values: [{ id: 'ME', label: 'Me' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'ME_ALTERNATE', label: 'Me (Alternate)' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
					applyAsDefault: false,
				},
				{
					values: [{ id: 'null', label: 'Unassigned' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{
								type: 'rule',
								action: 'clients:view:unassigned',
								negated: false,
							},
						],
					},
					applyAsDefault: false,
				},
			],
			// Unlike other lists, we omit applyDefaultIf because "My Clients" should default
			// to the bounded set for everyone (admins see ME+Unassigned based on their permissions too).
			// Bound is tied to clients:list:any so users granted "list any" (whether
			// salesperson, sales manager, or admin) can freely change the filter on this
			// tab; users without list:any stay scoped to ME / unassigned.
			boundedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
		},
	},
	kanbanConfig: createClientKanbanConfig(),
};
